import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable, of, throwError} from 'rxjs';
import {catchError, switchMap} from 'rxjs/operators';
import {environment} from "@environment";

@Injectable({
  providedIn: 'root'
})
export class RequestService {

  constructor(
    public http: HttpClient,
  ) {
  }

  post(url: any, params?: any, apiType = 'bms', token = null): Observable<any> {
    const headers = this.getHeaders(token);
    const httpOptions = {
      headers,
    };
    let baseUrl = RequestService.getBaseDomain(apiType);

    return this.http
      .post(baseUrl + url, params, httpOptions).pipe(
        switchMap((response: any) => {
          if (response.success) {
            return of(response);
          } else {
            console.log(response);
            return throwError(response);
          }
        }), catchError(errorResponse => {
          return throwError(errorResponse.errors);
        }));
  }

  get(url: any, params?: any, apiType = 'bms', token = null): Observable<any> {
    const headers = this.getHeaders(token);
    const httpOptions = {
      headers,
    };
    let baseUrl = RequestService.getBaseDomain(apiType);

    let queryParams = this.toParam(params);
    queryParams = (queryParams) ? '?' + queryParams : '';
    return this.http
      .get(baseUrl + url + queryParams, httpOptions).pipe(
        switchMap((response: any) => {
          if (response.success) {
            return of(response);
          } else {
            throw (response);
          }
        }), catchError(errorResponse => {
          throw (errorResponse.errors);
        }));
  }

  create(url: any, data: any) {
    return this.post(url, data);
  }

  read(url: any, id: any) {
    return this.get(url + '/' + id);
  }

  update(url: any, id: any, data: any) {
    return this.post(url + '/' + id, data);
  }

  getHeaders(token) {
    try {
      let headers = new HttpHeaders();
      if(token){
        headers = headers.append('token', token);
      }
      return headers;
    } catch (error) {
      console.log('Error in Request Service get Headers');
      console.log(error);
      return;
    }
  }

  public toParam(obj: any) {
    if (obj) {
      return Object.keys(obj).map(key => {
        const val = obj[key];
        const prefix = encodeURIComponent(key);
        return Array.isArray(val)
          ? _toPhpQueryArray(val, prefix)
          : _toPhpQueryObject(val, prefix);
      }).join('&');


      function _toPhpQueryArray(arr: any, prefix: any) {
        return arr.map((v: any) => prefix + '[]=' + encodeURIComponent(v)).join('&');
      }

      function _toPhpQueryObject(value: any, prefix: any) {
        if (typeof value === 'object' && value) {
          return Object.keys(value).map(k => _toPhpQueryObject(value[k], prefix + '[' + encodeURIComponent(k) + ']')).join('&');
        } else {
          return prefix + '=' + encodeURIComponent(value);
        }
      }
    } else {
      return null;
    }
  }

  private static getBaseDomain(apiType: string) {
    if (apiType === 'bms') {
      return  environment.baseUrlProtocol + environment.bms_api_domain;
    } else if (apiType === 'nitro') {
      return  environment.baseUrlProtocol + environment.nitro_api_domain;
    } else {
      return throwError('Invalid API domain')
    }
  }
}
